import { createMultiStyleConfigHelpers, ThemingProps } from '@chakra-ui/react'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import {
  createCustomStyleContext,
  useCustomMultiStyleConfig,
} from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const { NewFaxLoadingView } = themeColorSectionKeys.fax
const newFaxLoadingViewStyleParts = ['container', 'circularProgress'] as const

const helpers = createMultiStyleConfigHelpers(newFaxLoadingViewStyleParts)
export const NewFaxLoadingViewStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      alignItems: 'center',
      justifyItems: 'center',
      gap: '1.5rem',
      py: '1.75rem',
      px: '1.5rem',
      userSelect: 'none',
      backgroundColor: NewFaxLoadingView.Background,
    },
    circularProgress: {
      width: '6px',
      height: '9rem',
      backgroundColor: NewFaxLoadingView.CircularProgress.TrackColor,
      color: NewFaxLoadingView.CircularProgress.ProgressColor,
    },
  },
})

const themeKey = getName({ NewFaxLoadingViewStyle })
export const useNewFaxLoadingViewStyle = (props?: ThemingProps) =>
  useCustomMultiStyleConfig<typeof newFaxLoadingViewStyleParts>(themeKey, props)

export const createNewFaxLoadingViewStyleContext = () =>
  createCustomStyleContext<typeof newFaxLoadingViewStyleParts>(themeKey)
